import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovStartvectorStateProps,
    LoadMarkovStartvectorStateById,
    setMarkovStartvectorStateEdit,
    setMarkovStartvectorStateReloadEdit,
    initMarkovStartvectorState,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    stateId = null,
}: MarkovStartvectorStateProps) => {
    const startvectorSelected = useSelector((state: StoreType) => state.markovStartvector.startvectorSelected)

    const startvectorState = useSelector((state: StoreType) => state.markovStartvectorState.stateEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovStartvectorState.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovStartvectorStateReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovStartvectorStateReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (stateId === 0) {
            dispatch(setMarkovStartvectorStateEdit(initMarkovStartvectorState))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovStartvectorStateById(stateId, startvectorSelected.id).then((res) => {
                dispatch(setMarkovStartvectorStateEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!startvectorState) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editStartvectorState}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form startvectorState={startvectorState} />
                }
                {
                    reloadEdit
                    && <Form startvectorState={startvectorState} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
